"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ActivityButton;
exports.customActivityButton = customActivityButton;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _queryLdflex = _interopRequireDefault(require("@solid/query-ldflex"));

var _util = require("../util");

var _useLDflexValue = _interopRequireDefault(require("../hooks/useLDflexValue"));

var as = _queryLdflex.default.context.as;
/**
 * Button that displays whether the user has performed an activity;
 * when clicked, performs the activity.
 */

function ActivityButton(_ref) {
  var _ref$activityType = _ref.activityType,
      activityType = _ref$activityType === void 0 ? "".concat(as, "Like") : _ref$activityType,
      _ref$object = _ref.object,
      object = _ref$object === void 0 ? "[".concat(window.location.href, "]") : _ref$object,
      children = _ref.children,
      _ref$shortName = _ref.shortName,
      shortName = _ref$shortName === void 0 ? /\w*$/.exec(activityType)[0] : _ref$shortName,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "solid activity ".concat(shortName.toLowerCase()) : _ref$className,
      _ref$activateText = _ref.activateText,
      activateText = _ref$activateText === void 0 ? shortName : _ref$activateText,
      _ref$deactivateText = _ref.deactivateText,
      deactivateText = _ref$deactivateText === void 0 ? activateText : _ref$deactivateText,
      _ref$activateLabel = _ref.activateLabel,
      activateLabel = _ref$activateLabel === void 0 ? children ? [activateText, ' ', children] : activateText : _ref$activateLabel,
      _ref$deactivateLabel = _ref.deactivateLabel,
      deactivateLabel = _ref$deactivateLabel === void 0 ? children ? [deactivateText, ' ', children] : deactivateText : _ref$deactivateLabel,
      props = _objectWithoutProperties(_ref, ["activityType", "object", "children", "shortName", "className", "activateText", "deactivateText", "activateLabel", "deactivateLabel"]);

  // Look up a possibly existing activity
  object = (0, _util.srcToLDflex)(object);

  var _ref2 = (0, _react.useState)(),
      _ref3 = _slicedToArray(_ref2, 2),
      exists = _ref3[0],
      setExists = _ref3[1];

  var activity = (0, _useLDflexValue.default)("".concat(object, ".findActivity(\"").concat(activityType, "\")"));
  if (exists === undefined && activity) setExists(true); // Creates a new activity (if none already exists)

  function toggleActivity() {
    return _toggleActivity.apply(this, arguments);
  } // Return the activity button


  function _toggleActivity() {
    _toggleActivity = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var action;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // Optimistically display the result
              setExists(!exists);
              _context.prev = 1;
              // Try performing the action
              action = !exists ? 'create' : 'delete';
              _context.next = 5;
              return _queryLdflex.default.resolve("".concat(object, ".").concat(action, "Activity(\"").concat(activityType, "\")"));

            case 5:
              // Confirm the result (in case a concurrent action was pending)
              setExists(!exists);
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              // Revert to the previous state
              setExists(exists);
              console.warn('@solid/react-components', _context.t0);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _toggleActivity.apply(this, arguments);
  }

  className = "".concat(className, " ").concat(exists ? 'performed' : '');
  return _react.default.createElement("button", (0, _extends2.default)({
    className: className,
    onClick: toggleActivity
  }, props), exists ? deactivateLabel : activateLabel);
} // Internal helper for creating custom activity buttons


function customActivityButton(type, activate, deactivate, deactivateNoChildren) {
  var activityType = "".concat(as).concat(type);
  return function (_ref4) {
    var object = _ref4.object,
        _ref4$children = _ref4.children,
        children = _ref4$children === void 0 ? object ? null : 'this page' : _ref4$children,
        _ref4$activateText = _ref4.activateText,
        activateText = _ref4$activateText === void 0 ? activate : _ref4$activateText,
        _ref4$deactivateText = _ref4.deactivateText,
        deactivateText = _ref4$deactivateText === void 0 ? children ? deactivate : deactivateNoChildren : _ref4$deactivateText,
        props = _objectWithoutProperties(_ref4, ["object", "children", "activateText", "deactivateText"]);

    return _react.default.createElement(ActivityButton, (0, _extends2.default)({}, props, {
      activityType: activityType,
      object: object,
      children: children,
      activateText: activateText,
      deactivateText: deactivateText
    }));
  };
}